import { select } from "d3-selection";

export default selector => {
  let data = [];

  const $ = () => {
    const selection = select(selector);

    const container = selection
      .append("div")
      .attr("class", "step vh-100 w-100 with-navbar")
      .attr("id", "areas")
      .append("div")
      .attr("class", "container-fluid h-100 d-flex w-100 flex-column");

    container
      .append("div")
      .attr(
        "class",
        "row align-items-center justify-content-center flex-shrink-0 flex-grow-0"
      )
      .append("div")
      .attr("class", "col-12")
      .append("p")
      .attr("class", "text-center text-step my-5")
      .text("Select the research area you want to explore");

    const areasRow = container
      .append("div")
      .attr("class", "row flex-shrink-1 flex-grow-1 px-5");

    const areas = areasRow.selectAll(".homeAreas").data(data, function(d) {
      return d.step;
    });

    const card = areas
      .enter()
      .append("div")
      .attr("class", "areas-col d-flex mx-1")
      .append("div")
      .attr("class", function(d, i) {
        let margin = "0";
        if (i === 0 || i === 4) {
          margin = "5";
        } else if (i === 1 || i === 3) {
          margin = "3";
        }
        return `homeAreas mt-${margin} ${d.published === "FALSE" ? "disabled" : ""}`;
      })
      .append("a")
      .attr("href", function(d) {
        return d.published === "FALSE" ? "" : d.url;
      })
      .attr("class", "homeAreasLink")
      .style("pointer-events", function(d) {
        return d.published === "FALSE" ? "none" : "all";
      });

    card
      .append("img")
      .attr("src", function(d) {
        return d.img_url;
      })
      .attr("class", "img-fluid flex-shrink-0 flex-grow-0");

    card
      .append("h5")
      .attr("class", "flex-shrink-0 flex-grow-0")
      .text(function(d) {
        return d.title;
      });

    card
      .append("p")
      .attr("class", "flex-shrink-1 flex-grow-1")
      .style("overflow-y", "auto")
      .text(function(d) {
        return d.desc;
      });

    card
      .append("a")
      .attr("href", function(d) {
        return d.url;
      })
      .attr("class", function(d) {
        return d.published === "FALSE"
          ? "btn btn-light mb-3 disabled flex-shrink-0 flex-grow-0"
          : "btn btn-light mb-3 flex-shrink-0 flex-grow-0";
      })
      .attr("role", "button")
      .text(function(d) {
        return d.published === "FALSE" ? "soon online" : "explore ⟶";
      });

    card.on("click", function(d) {
      console.log(window.location);
      //window.location = d.url;
    });
  };

  $.data = _ => {
    data = _;
    return $;
  };

  return $;
};
